// extracted by mini-css-extract-plugin
module.exports = {"form_section":"ContactScreen_form_section__1MT0v"};